import { useMemo } from 'react';
import { DateTime } from 'luxon';
import { useDateQueryParams } from '../../../hooks';
export var useFindShiftsPageQueryParams = function () {
    var selectedDate = useDateQueryParams().selectedDate;
    var initialSelectedDate = useMemo(function () { return selectedDate; }, []);
    // Start time to begin at present
    var startTime = useMemo(function () { return DateTime.now().startOf('day').toUTC().toISO(); }, [initialSelectedDate]);
    // 70 days for any kind of associate, this will be clipped appropriately by backend
    var endTime = useMemo(function () { return DateTime.now().plus({ days: 70 }).endOf('day').toUTC().toISO(); }, [initialSelectedDate]);
    return {
        selectedDate: initialSelectedDate,
        startTime: startTime,
        endTime: endTime
    };
};
